<app-exam-header [pageTitle]="'Forums'"></app-exam-header>
<main class="container">
  <div class="row">
    <div class="col-md-12 text-right mt-4 mb-4">
      <button class="pbmit-btn add-question-btn" (click)="addQuestion()">
        <i class="fa fa-plus-circle" style="font-size: 1.8vh;"></i> <span style="font-size: 1.8vh;">Add Question</span>
      </button>
    </div>
  </div>
  
  <!-- Forum Questions List -->
  <div class="questions-container">
    <div class="question" *ngFor="let forum of paginatedForums; let i = index;">
      <div class="voting">
        <span class="vote-count" style="font-size: 2vh;">{{(currentPage-1) * pageSize + i + 1}}</span>
        <svg class="accepted" xmlns="http://www.w3.org/2000/svg" width="2.5vh" height="2.5vh" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="8" r="7" />
          <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
        </svg>
      </div>

      <div class="content">
        <h2 (click)="openDetails(forum)" class="question-title">{{forum.title}}</h2>
        <p class="question-description" [innerHTML]="forum.description"></p>

        <div class="metadata">
          <span class="metadata-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.8vh" height="1.8vh" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            <a (click)="openDetails(forum)" style="cursor: pointer; font-size: 1.6vh;">{{forum.discussion_count}} answers</a>
          </span>
          <span class="metadata-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.8vh" height="1.8vh" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <span style="font-size: 1.6vh;">{{forum.forum_date | date:'yyyy/MM/dd'}}</span>
          </span>
          <span class="metadata-item user-info">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.8vh" height="1.8vh" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span style="font-size: 1.6vh;">Asked by {{forum.user_name}}</span>
          </span>
        </div>

        <!-- Answers -->
        <div class="answers">
          <div class="answer">
            <div class="voting">
              <button class="vote-button up">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 18v-6H5l7-7 7 7h-4v6H9z" />
                </svg>
              </button>
              <span class="vote-count">56</span>
              <button class="vote-button down">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 6v6H5l7 7 7-7h-4V6H9z" />
                </svg>
              </button>
              <svg class="accepted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="8" r="7" />
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
              </svg>
            </div>
            <div class="answer-content">
              <p>The most modern and flexible way to center a div is using Flexbox. Add these CSS properties to the parent
                container:

                display: flex;
                align-items: center;
                justify-content: center;</p>
              <div class="metadata">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  1 hour ago
                </span>
                <span>Answered by CSSMaster</span>
              </div>
            </div>
          </div>

          <div class="answer">
            <div class="voting">
              <button class="vote-button up">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 18v-6H5l7-7 7 7h-4v6H9z" />
                </svg>
              </button>
              <span class="vote-count">23</span>
              <button class="vote-button down">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 6v6H5l7 7 7-7h-4V6H9z" />
                </svg>
              </button>
            </div>
            <div class="answer-content">
              <p>You can also use CSS Grid:

                display: grid;
                place-items: center;</p>
              <div class="metadata">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  45 minutes ago
                </span>
                <span>Answered by GridGuru</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Pagination -->
  <div class="pagination-container" *ngIf="totalItems > pageSize">
    <div class="pagination">
      <button class="pagination-btn" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      
      <button *ngIf="pages[0] > 1" class="pagination-btn" (click)="onPageChange(1)">1</button>
      <span *ngIf="pages[0] > 2" class="pagination-ellipsis">...</span>
      
      <button *ngFor="let page of pages" class="pagination-btn" 
              [class.active]="page === currentPage"
              (click)="onPageChange(page)">
        {{page}}
      </button>
      
      <span *ngIf="pages[pages.length-1] < totalPages - 1" class="pagination-ellipsis">...</span>
      <button *ngIf="pages[pages.length-1] < totalPages" class="pagination-btn" (click)="onPageChange(totalPages)">{{totalPages}}</button>
      
      <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="onPageChange(currentPage + 1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
  </div>
  
  <!-- Empty state if no forums -->
  <div class="empty-state" *ngIf="forums && forums.length === 0">
    <div class="empty-state-content">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
      <h3>No questions yet</h3>
      <p>Be the first to ask a question!</p>
      <button class="pbmit-btn" (click)="addQuestion()">Ask a Question</button>
    </div>
  </div>
</main>
<app-exam-footer class="footer"></app-exam-footer>